import { Link } from 'react-router-dom';
import { Paywall } from '/src/components/Paywall';

import UfoPNG from '@crazyegginc/hatch/dist/images/illustration-ufo-gathering.png';
import UfoWebP from '@crazyegginc/hatch/dist/images/illustration-ufo-gathering.webp';

export function NotInstalledWall() {
  return (
    <Paywall>
      <Paywall.Image webp={UfoWebP} fallback={UfoPNG} width="185px" height="160px" />
      <Paywall.Title>To get started, install the tracking script</Paywall.Title>
      <Paywall.Body>
        To start tracking traffic and visitor behavior,
        <br />
        you&apos;ll need to install the tracking script.
      </Paywall.Body>
      <Paywall.Button component={Link} to="/install">
        Install tracking script
      </Paywall.Button>
    </Paywall>
  );
}

NotInstalledWall.displayName = 'NotInstalledWall';
